import { MessageStatus } from '@shared/models/enums/messages'
import { IMessage, INonQliqMessage } from '@shared/models/proto/base/messages'
import { IconColors } from '@shared/models/types/ui/app-icon'

const colors = {
  [MessageStatus.READ]: 'primary' as IconColors,
  [MessageStatus.SENT]: 'secondary' as IconColors,
}

export const getStatusIcon = (message: IMessage | INonQliqMessage) => {
  const readTime =
    (message as INonQliqMessage)?.readTime ??
    (message as IMessage)?.actualStatus?.readTime

  return readTime && readTime !== '0' ? MessageStatus.READ : MessageStatus.SENT
}

export const getStatusIconColor = (shape: MessageStatus) => colors[shape]
